import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { golf } from './enums';
import { NamespaceShape, withNamespace } from '@ux/namespace-component/lib';

export function DropdownHeader({ loggedIn, name, preset }) {
  if (loggedIn && name) {
    return name;
  }
  return (
    <FormattedMessage id={ preset === 'internal-header' ? golf.internalModeTitle : golf.title } />
  );
}

DropdownHeader.propTypes = {
  ...NamespaceShape,
  loggedIn: PropTypes.bool,
  name: PropTypes.string,
  preset: PropTypes.string
};

export default withNamespace(DropdownHeader);
